import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://hsaservicehub.com";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_financial-tax-legal/artifacts/t1ar68a0_HSA_Logo1.png";

export default function SEO({
  title,
  description,
  keywords,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd = null,
}) {
  const fullTitle = title ? `${title} | HSA Service Hub` : "HSA Service Hub | Financial, Tax, Insurance & Legal Services USA";
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
